import { CardMedia } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = /* istanbul ignore next */ () => ({
  root: {
    paddingTop: '56.25%', // 16:9
  },
});

const CardImage = ({ src, ...props }) => <CardMedia {...props} image={src} />;

export default withStyles(styles)(CardImage);
